<template>
  <div>
    <custom-dialog
      :visible.sync="open"
      :options="dialogOptions"
      ref="yxqnAlert"
      width="520px">
      <div class="alert-container">
        <div class="content">
          {{content}}
        </div>
        <div class="btn-actions">
          <div class="cancel-btn" v-if="dialogType===ALERT_TYPE.CONFIRM" @click="cancel()">{{cancelBtnText}}</div>
          <div class="confirm-btn" @click="confirm">{{confirmBtnText}}</div>
        </div>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import { ALERT_TYPE } from './index'

export default {
  name: 'yxqnAlert',
  data () {
    return {
      ALERT_TYPE,
      open: false,
      dialogOptions: {
        titleHeight: 44,
        titleFontSize: 18,
        showClose: false
      },
      cancelBtnText: '取消',
      confirmBtnText: '我知道了',
      content: '这里是内容',
      dialogType: ALERT_TYPE.CONFIRM
    }
  },
  methods: {
    show (config) {
      return new Promise((resolve, reject) => {
        this.resolve = resolve
        this.reject = reject
      })
    },
    confirm () {
      this.resolve()
      this.hide()
    },
    cancel () {
      if (this.dialogType === this.ALERT_TYPE.ALERT) {
        this.resolve()
      }
      if (this.dialogType === this.ALERT_TYPE.CONFIRM) {
        this.reject()
      }
      this.hide()
    },
    hide () {
      this.open = false
    }
  }
}
</script>

<style scoped lang="less">
  @import "../../styles/customMixin.less";

  .alert-container {
    padding: 60px 40px 40px;
    box-sizing: border-box;
  }

  .content {
    .flexMixin();
    line-height: 1.5;
  }

  .btn-actions {
    .flexMixin();
    margin-top: 40px;

    .cancel-btn {
      .yxqn-btn-cancel();
      margin-right: 20px;
    }

    .confirm-btn {
      .yxqn-btn-primary();
    }
  }
</style>
